import React from 'react';
import { Label } from 'semantic-ui-react';

const ReviewStateInfo = ({ content }) => {
  // TODO review state is not translated -> should be done in backend
  const getReviewStateTitle = (review_state_id) => {
    const reviewStates = {
      in_work: 'In Bearbeitung',
      release_control: 'Zur Freigabe',
      discussion: 'Zur Diskussion',
      verified: 'Verifiziert',
    };
    return reviewStates[review_state_id] || review_state_id;
  };

  if (content.review_state !== 'verified') {
    return (
      <Label className={`review-state ${content.review_state}`}>
        {getReviewStateTitle(content.review_state)}
      </Label>
    );
  } else {
    return <></>;
  }
};

export default ReviewStateInfo;
